import styled from "styled-components";
import { naira } from "../../../../utils/data";
import { ICON_ARROW_UP, ICON_EYE_FILL } from "../../../../utils/icons";
import { yellow_circle } from "../../../../assets";


const StoreAccount = () => {
      return (
            <StyledStoreAccount>
                  <div className="main-container">
                        <div className="d-flex gap-3">
                              <div className="">
                                    <img src={yellow_circle} alt="circle" width='100px' />
                              </div>
                              <div className="w-100">
                                    <h5 className="grey-bold-text mb-4">
                                          Store Account
                                    </h5>
                                    <small className="grey-text">
                                          Current Balance
                                    </small>
                                    <div className="d-flex gap-3 justify-content-between">
                                          <div className="">
                                                <h4 className="">
                                                      {naira}9,600,000.00
                                                </h4>
                                          </div>
                                          <div className="">
                                                <span className="me-3 h4">
                                                      {ICON_EYE_FILL}
                                                </span>
                                                <div className="badge badge-success">
                                                      {ICON_ARROW_UP}
                                                      +2.43
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </StyledStoreAccount>

      );
};

export default StoreAccount;

const StyledStoreAccount = styled.section`


`;